import React, { FC, useState } from "react";
import "./ProductItem.scss";
import ImageSrc from "../../../../../Components/ImageSrc/ImageSrc";
import {
  CurrencyFormatter,
  CurrencyFormatter2,
} from "../../../../../Helpers/CurrencyFormatter";
import QuoteRequest from "../../../Components/ProductSinglePage/QuoteRequest/QuoteRequest";
import { productType } from "Models";
import AddWishList from "../AddWishList/AddWishList";
import { Overlay, Tooltip } from "react-bootstrap";

interface propsType {
  data: productType;
}
const ProductItem: FC<propsType> = ({ data }) => {
  const [show, setShow] = useState(false);
  // const target = useRef(null);

  console.log("productItem data", data);

  return (
    // <div className="productItem col-6 col-sm-6 col-lg-3">
    <>
      <div className="col-6 col-sm-6 col-lg-3">
      <div className="position-relative">
        <div className="wishlist-overlay">
           <AddWishList productUuid={data.productUuid}></AddWishList>
         </div>
        <div className="imgConEstate">
          <a
            href={
              data.hasVariants
                ? `/products/variant/${data.productUuid}`
                : `/product/${data.productUuid}`
            }
          >
            <ImageSrc
              src={data?.images[0]?.url}
              alt={data.productName}
              title={data.productName}
              width="product-image img-fluid"
            ></ImageSrc>
          </a>
        </div>
        </div>
        <div className="contentConstruction">
          <h3 className="product-title">{data.productName}</h3>

          <div className="priceUnit">
            <div className="firstCon">
              <div className="col-8">
                {data.unitPromoPriceForBuyer !== 0 ? (
                  <div className="price">
                    <div className="old-price me-1 d-none">
                      {data.currencySymbol}
                      {CurrencyFormatter(data.unitPromoPriceForBuyer)}
                    </div>
                    <div className="new-price">
                      {data.currencySymbol}
                      {CurrencyFormatter(data.unitPriceForBuyer)}
                    </div>
                    <span className="perUnit">
                      per
                      {data.unitOfMeasurement ===
                      "Personal Protective Equipment"
                        ? "units"
                        : data.unitOfMeasurement}
                    </span>
                  </div>
                ) : (
                  <div className="price">
                    <div className="new-priceV2">
                      {data.unitPriceForBuyer !== 0 ? (
                        <div className="">
                          {data.currencySymbol}
                          {CurrencyFormatter2(data.unitPriceForBuyer)}
                          <span className="perUnit">
                            per{" "}
                            {data.unitOfMeasurement ===
                            "Personal Protective Equipment"
                              ? "unit"
                              : data.unitOfMeasurement}
                          </span>
                        </div>
                      ) : (
                        <>
                          <button
                            onClick={() => setShow(true)}
                            className="quoteRequestBtn text-decoration-none"
                          >
                            Request quote
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <span className="units">
              {data.maximumQuantity}{" "}
              {data.unitOfMeasurement === "Personal Protective Equipment"
                ? " units"
                : data.unitOfMeasurement}
            </span>

            {/* <span>{data.price}</span> */}
            {/* <span className="perUnit">per unit</span> */}
          </div>
        </div>
      </div>

      <QuoteRequest
        productDetail={data}
        show={show}
        hide={(val: boolean) => setShow(val)}
      ></QuoteRequest>
    </>
  );
};

export default ProductItem;
